const inputMaxCharacters = (wrapSelector, inputSelector, textSelector) => () => {
    const fieldList = document.querySelectorAll(wrapSelector);

    const handleFieldLength = (event, fields) => {
        fields.forEach((field) => {
            const input = field.querySelector(inputSelector);
            const maxLength = input && input.maxLength;
            const infoText = field.querySelector(textSelector);

            if (maxLength > 0 && infoText) {
                infoText.textContent = maxLength;

                field.addEventListener(event, () => {
                    const charactersLeft = maxLength - input.value.length;
                    infoText.textContent = charactersLeft.toString();
                });
            }
        });
    };

    handleFieldLength("keyup", fieldList);
    handleFieldLength("keydown", fieldList);
};

export default inputMaxCharacters;



// WEBPACK FOOTER //
// ./assets/js/modules/input-max-characters.js